/*
 * @Author: IT-Jarvis
 * @Date: 2022-01-21 11:56:33
 * @LastEditTime: 2022-01-24 10:34:01
 * @LastEditors: IT-Jarvis
 * @Description:
 * @FilePath: \twswyTwoYear\src\js\common.js
 */
$(function () {
	$(".tab > li").each(function () {
		var _index = $(this).index();
		$(this).click(function () {
			$(this).parents().children().removeClass("current");
			$(this).addClass("current");
			$(".bg-tab>div")
				.eq(_index)
				.addClass("show")
				.show()
				.siblings()
				.removeClass("show")
				.hide();
		});
	});
});

$(function () {
	$(".act-tab > li").each(function () {
		var _index = $(this).index();
		$(this).click(function () {
			$(this).parents().children().removeClass("current");
			$(this).addClass("current");
			$(".act-info>div")
				.eq(_index)
				.addClass("show")
				.show()
				.siblings()
				.removeClass("show")
				.hide();
		});
	});
});

// 页面置顶
$(function () {
	$(".btn-on").click(function () {
		rightmove();
		$(this).hide();
		$(".btn-off").show();
		$(".nav-box").show();
		$(".btn-nav").animate({ right: $(".nav-box").width() }, 0);
	});
	$(".btn-off").click(function () {
		leftmove();
		$(this).hide();
		$(".btn-on").show();
		$(".btn-nav").animate({ right: 0 }, 0);
	});
});
function rightmove() {
	$(".nav-box").animate({ right: 0 }, 0);
}
function leftmove() {
	$(".nav-box").animate({ right: -$(".nav-box").width() }, 0);
}
function sto(cl) {
	var t = $(cl).offset().top;
	$("body,html").animate({ scrollTop: t }, 300);
}

window.rightmove = rightmove;
window.leftmove = leftmove;
window.sto = sto;
